import { withSvgIcon } from './withSvgIcon';

export const AlertInfo = withSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM13.2 7.47131C13.2 8.13403 12.6627 8.67126 12 8.67126C11.3373 8.67126 10.8 8.13403 10.8 7.47131C10.8 6.8086 11.3373 6.27136 12 6.27136C12.6627 6.27136 13.2 6.8086 13.2 7.47131ZM10 9.6H9.1V11.4H10H11.1V15.6H10H9.1V17.4H10H12H14H14.9V15.6H14H12.9V10.5C12.9 10.0029 12.4971 9.6 12 9.6H10Z"
    fill="currentColor"
  />,
  { viewBox: '0 0 24 24' },
);
